<!--Loading Page-->
<div class="k-loading-image" *ngIf="!result.hasReceivedResult"></div>

<section class="nitrogen-compliance-widget-container" *ngIf="result.hasReceivedResult">
    <div class="nitrogen-compliance-search-container">
        <!--Vehicle Application Drop Down List-->
        <section class="nitrogen-compliance-container">
            <kendo-dropdownlist #nitrogenComplianceFilter
                                [data]="listItems"
                                [(ngModel)]="selectedFilterValue"
                                (ngModelChange)="changeFilter($event)">
            </kendo-dropdownlist>
        </section>
    </div>

    <!--Scroll Container-->
    <section class="widget-scroll-container nitrogen-compliance-widget-scroll-container">
        <!--Title Container-->
        <section class="widget-scroll-title-container">
            <!--Vehicle Serial Number Title-->
            <div class="widget-scroll-title">
                <b>{{ui.serialNumber}}</b>
            </div>
            <!--Vehicle Pressure Check Per Vehicle Title-->
            <div class="widget-scroll-title">
                <b>{{ui.compliance}}</b>
            </div>
        </section>
        <!--Item Container-->
        <div>
            <section *ngFor="let vehicle of selectedVehicles">
                <a class="widget-scroll-row" href="/#!/vehicle/search" (click)="setSearchBy(vehicle.serialNumber)">
                    <!--Vehicle Serial Number Item-->
                    <div class="widget-scroll-col">
                        <a href="/#!/vehicle/search" class="text-u-l">{{vehicle.serialNumber}}</a>
                    </div>
                    <!--Nitrogen Compliant-->
                    <div class="widget-scroll-col" align="right">
                        {{vehicle.compliant ? ui.yes : ui.no}}
                    </div>
                </a>
            </section>
        </div>
    </section>
</section>